module.exports = {"TXTWCL_Singles":{"id":"TXTWCL_Singles","defaultMessage":"Einzelwetten","track":"Singles","ontario":"Einzelwetten"}}